import DefaultModal from "components/Common/Modal/DefaultModal";
import React from "react";
import styled from "styled-components";
import KakaoIcon from "assets/signup/icon_kakao.svg";
import GoogleIcon from "assets/signup/icon_google.svg";
import { useLocation } from "react-router-dom";
import { GOOGLE_URL, KAKAO_URL } from "constant/constant";

const SigninModal = ({ modalClose }: { modalClose: () => void }) => {
  const location = useLocation();

  const handlePath = () => {
    localStorage.setItem("path", location.pathname);
  };

  return (
    <DefaultModal
      handlModalClose={modalClose}
      state="none"
      title="로그인"
      content={`병/의원을 위한 이미지 컨설팅 플랫폼 Charting\n병원의 시작부터 끝까지 함께해보세요`}
    >
      <ButtonContainer>
        <ModalButton href={GOOGLE_URL} onClick={handlePath}>
          <img src={GoogleIcon} alt="buttonIcon" />
          <div> 구글로 시작하기</div>
        </ModalButton>
        <ModalButton href={KAKAO_URL} onClick={handlePath}>
          <img src={KakaoIcon} alt="buttonIcon" />
          <div>카카오로 시작하기</div>
        </ModalButton>
      </ButtonContainer>
    </DefaultModal>
  );
};

export default SigninModal;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
`;

const ModalButton = styled.a`
  border-radius: 1.2rem;
  border: 1px solid #d8dce5;
  background: #fff;
  padding: 1.2rem 1.6rem;
  box-sizing: border-box;
  align-items: center;
  cursor: pointer;
  height: 4.8rem;
  gap: 1.3rem;
  display: flex;
  text-decoration: none;

  div {
    color: #000;
    font-size: 1.6rem;
    font-weight: 400;
    letter-spacing: 0.15px;
    line-height: 150%;
  }
`;
